export default "__VITE_ASSET__9804621c__"